/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Sv } from './Sv';

class ServantFreightTemplate extends Sv {
    constructor() {
        super();
        this.baseUrl += '/servantFreightTemplate';
    }

    data({ templateName, billingMethod, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            templateName,
            billingMethod,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, templateName, billingMethod, templateDesc, isAvailable, servantFreightTemplateRgStr } = {}) {
        return super.post('/save', {
            id,
            templateName,
            billingMethod,
            templateDesc,
            isAvailable,
            servantFreightTemplateRgStr,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    select() {
        return super.get('/select', {});
    }

    editServantFreightTemplate({ id, chargeDesc }) {
        return super.post('/editservantFreightTemplate', { id, chargeDesc });
    }
}

export default new ServantFreightTemplate();
export { ServantFreightTemplate };
